import {IContainerProps} from '@platform';

import IFocusableComponentOptions from '../Interfaces/IFocusableComponentOptions';
import IGridProps from '../Interfaces/IGridProps';
import IVirtualContainerProps from '../Interfaces/IVirtualContainerProps';

type TPossibleProps = {
    children?: React.ReactNode;
} & Partial<IContainerProps & IGridProps & IVirtualContainerProps> &
    IFocusableComponentOptions;

/**
 * The following is a declarative means of subtracting all props
 * which are not part of `HTMLElementAttributes` or `ViewProps` from
 * the injected and consumer-provided props of the component to ensure
 * that all native props can be passed safely through to the underlying
 * `element`.
 */

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const extractElementAttributesFromProps = (props: TPossibleProps) => {
    const {
        actions,
        children,
        columns,
        delegateChangeFocus,
        disableFocus,
        focusableBasis,
        focusableAnchors,
        focusableId,
        focusableIndex,
        focusOnMount,
        getFocusableId,
        itemsLength,
        justify,
        finalGridRowAlign,
        loop,
        onBlur,
        onDown,
        onFocus,
        onFocusWillChange,
        onLeft,
        onRight,
        onSelect,
        onUp,
        startIndex,
        throttleDurationMs,
        virtualFocusedIndex,
        ...extractedElementAttributes
    } = props;

    return extractedElementAttributes;
};

export default extractElementAttributesFromProps;
